import { Component,OnInit,NgZone, Renderer2,AfterViewInit} from '@angular/core';
import {CatalogueService} from '../../services/catalogue.service'
import {base_https_url,BRAND_APPROVED_ERRORS,excludedReferPICardsCataloguePage ,excludedReferEarnCardsCategories, REDIRECT_SWIFT_URL} from '../../config/app-settings.config';
import { cardAnimations } from 'src/app/utilities/animations';
import { DomSanitizer } from '@angular/platform-browser';
import { IwService } from "../../services/iw.service";
import { Router, ActivatedRoute } from '@angular/router';
import { ThemeService } from 'src/app/services/theme.service';
import { xmlToJson, getDeviceSize } from '../../utilities/utilities.file'
import { SharedServiceService } from 'src/app/services/shared-service.service';
declare var $: any;
declare var _satellite: any;
declare var catalogue_card_click: Function;
declare var virtual_page_load: Function;
@Component({
  selector: 'app-catlogue-refer',
  templateUrl: './catlogue-refer.component.html',
  styleUrls: ['./catlogue-refer.component.scss'],
  animations: [cardAnimations]
})
export class CatlogueReferComponent implements OnInit, AfterViewInit {
  dcrCardUrlMapping: any;
  eligibleCardList: any;
  redirectToSwift: boolean = false;
  constructor(
    private renderer: Renderer2,
    private catalogueService: CatalogueService,
    private ngZone: NgZone,
    private router: Router,
    private themeService: ThemeService,
    private route: ActivatedRoute,
    private iw: IwService,
    private _sanitizer: DomSanitizer,
    private sharedService: SharedServiceService) { }
  transform(style) {
    return this._sanitizer.bypassSecurityTrustStyle(style);
  }
  public sanitizeImage(image: string) {
    return this._sanitizer.bypassSecurityTrustStyle(`url(${base_https_url}${image})`);
  }
  isMobile: boolean;
  carddata: any;
  cardCatogoriesName: any = [];
  selectedCatoryName: any;
  selectedCardData: any = [];
  allCardData: any = [];
  totalCardsList: any = [];
  https_url: any;
  cardVisibleData: any;
  cardCount: any;
  totalcardCount: any;
  eapplyCataloguePageLabels: any;
  errorLabel: any = BRAND_APPROVED_ERRORS;
  excludedCards: any = excludedReferPICardsCataloguePage;
  excludedCardCategories: any = excludedReferEarnCardsCategories;
  offerLabels: any;
  cardErrorBlock: boolean = false;
  showCompareDialog: boolean = false;
  showCompareBox: boolean = false;
  isAnimationDisabled: boolean;
  compareDataLength: Number = 3;
  mainBlock: boolean = false;
  compareSmallBox: [];
  isMobileCompare: boolean = false;
  compareboxScroll: boolean = false;
  compareDisplayData: [];
  selectedIndex: any;
  seletedCategory: any;
  knowMoreData: any = false;
  knowMoreorder: Number;
  extraknowMoreData: any = [];
  CompareCardData: any = [];
  viewMoreBtnVisible: boolean = true;
  viewMoreLessVisible: boolean = false;
  disableAddtoCompare: boolean = true;

  ngOnInit() {
    this.selectedIndex = -1;
    this.knowMoreData = false;
    this.route.queryParams.subscribe(query => {
      if (query) {
        if (query.referralcode) {
          this.mainBlock = true;
          this.catalogueService.setRefferalCode(query.referralcode);
          this.catalogueService.referralCode = query.referralcode;
          console.log("referral code from catalogue refer component",this.catalogueService.referralCode);
          this.loadPageData();
          this.isAnimationDisabled = true;
        } else {
          this.mainBlock = false;
        }
      }
    });
    if (getDeviceSize() === 'small') {
      this.isMobile = true;
    }
    window.onresize = (e) => {
      this.ngZone.run(() => {
        if (getDeviceSize() === 'small') {
          this.isMobile = true;
        } else {
          this.isMobile = false;
        }
      });
    };

    // let url = "lifestyle/sbi-card-elite-advantage.dcr";
    // this.iw.getDcrXmlResponse(url, this.sharedService.paramschannel).subscribe((xml: any) => {
    //   console.log("entered getDCRXMLresponse from catalougue-refer component");
    //   if (xml) {                                       //================> this get call is not happening as there is no coonsole.log for this get. need to look
    //     console.log("getDcrXmlResponse from track application in catalougue-refer component", xml);
    //     this.sharedService.cardsContent = xml.uiContent.root.cardData.card;
    //     console.log("data from getDcrXmlResponse from catalougue-refer component ==>", this.sharedService.cardsContent);
    //   }
    // }, error => {
    //   console.log("Error from getDcrXmlResponse from catalougue-refer components");
    // });
    
  }

  loadPageData() {
    this.https_url = base_https_url;
    this.eapplyCataloguePageLabels = JSON.parse(JSON.stringify(this.iw.geteapplyFormLabelDcr().dcrContent.root)).eapply_refer;
    this.offerLabels = JSON.parse(JSON.stringify(this.eapplyCataloguePageLabels)).offerDetails;
    this.getAllCardDataLocal();

  }
  getAllCardDataLocal() {
    this.iw.getDcrXmlCardReponse().subscribe((res: any) => {
      if (res) {
        let convertedjson = res;
        let xmlJSON, xmlDoc;
        let parser = new DOMParser();
        xmlDoc = parser.parseFromString(convertedjson, "text/xml");
        xmlJSON = xmlToJson(xmlDoc);
        let parsedJSON;
        if (xmlJSON.hasOwnProperty('root')) {
          parsedJSON = JSON.parse(xmlJSON.root.json)
        } else {
          this.cardErrorBlock = true;
        }
        if (parsedJSON) {
          this.carddata = JSON.parse(xmlJSON.root.json);
          this.carddata.cardTypes.forEach(element => {
            if (!this.excludedCardCategories.includes(element.name)) {
              this.cardCatogoriesName.push(element);
              this.allCardData.push(element.cards);
            }
          });
          this.cardCatogoriesName.unshift({
            name: 'All',
            cImage: '/sbi-card-en/assets/media/images/personal/credit-cards/card-category-image/re_all.svg'
          });
          this.manipulateCardData();
        } else {
          this.cardErrorBlock = true;
        }

      }
    },
      (error) => {
        this.cardErrorBlock = true;
      })
  }

  manipulateCardData() {
    this.totalcardCount = 0;
    let totalCardsArray = [];
    this.allCardData.forEach(ele => {
      totalCardsArray.push(ele[0].details);
    })
    let finalAllCardsData = [];
    totalCardsArray.forEach(ele => {
      ele.forEach(element => {
        if (element.isEapply == 'yes' && element.isVisibleOnWebsite == 'yes' && !this.excludedCards.includes(element.name)) {
          finalAllCardsData.push(element)
        }
      });

    })
    this.totalCardsList = finalAllCardsData;
    this.totalcardCount = this.totalCardsList.length;
    this.selectedCardData = this.totalCardsList;
    this.cardCount = this.totalcardCount;
    this.selectedCatoryName = 'All Cards';
    this.seletedCategory = 'All';

  }
  catogoryCardData(items) {
    let catogoryCardData = [];
    items.cards[0].details.forEach(element => {
      if (element.isEapply == 'yes' && element.isVisibleOnWebsite == 'yes' && !this.excludedCards.includes(element.name)) {
        catogoryCardData.push(element)
      }
    });;
    return catogoryCardData;
  }
  showCards(items) {
    this.seletedCategory = items.name;
    this.knowMoreData = false;
    this.extraknowMoreData = [];
    this.selectedIndex = -1;
    if (items.name == 'All') {
      this.selectedCardData = this.totalCardsList;
      this.cardCount = this.selectedCardData.length;
      this.selectedCatoryName = 'All Cards';
    }
    else {
      this.selectedCardData = this.catogoryCardData(items);
      this.cardCount = this.selectedCardData.length;
      this.selectedCatoryName = items.name;
    }
    this.cardVisibleData = this.selectedCardData;
  }
  showKnowMore(items, pos) {
    this.resetFlags();
    if (this.selectedIndex == pos) {
      this.selectedIndex = -1;
    } else {
      this.selectedIndex = pos;
      this.knowMoreorder = this.getKnowMoreOrder(pos);
      this.updateOrder();
      this.selectedCardData = [...this.selectedCardData];
      this.knowMoreData = items;
      this.extraknowMoreData = false;
    }

  }
  updateOrder() {
    let elems: any = document.querySelectorAll('.re_card_box_.twolinetext');
    let index = 0, length = elems.length;
    for (; index < length; index++) {
      let knowmeindex = this.knowMoreorder;
      if (elems[index].style.order < knowmeindex) {
        elems[index].style.order = index + 1;
      } else if (elems[index].style.order == knowmeindex) {
        elems[index].style.order = +knowmeindex + 1;
      }
    }
  }

  getKnowMoreOrder(pos) {
    let desktopIndex = 3;
	let mobileIndex =2;
    let currentIndex = this.isMobile ? mobileIndex : desktopIndex;
    let openingIndex;

    console.log("Mobile ", this.isMobile);
    console.log("pos ", pos);
    console.log("currentIndex ", currentIndex);

    if (pos < currentIndex)
      openingIndex = currentIndex + 1;
    if (!this.isMobile) {
      if (pos == currentIndex) {
        openingIndex = pos + currentIndex + 1;
      }
      else if (pos % currentIndex == 0) {
        openingIndex = pos + currentIndex + 1;
      }

      else if (pos % currentIndex == 1) {
        openingIndex = pos + 3;
      }
      else if (pos % currentIndex == 2) {
        openingIndex = pos + 2;
      }
    } else {
      if (pos % currentIndex == 0) {
        openingIndex = pos + currentIndex + 1;
      }
      else if (pos % currentIndex == 1) {
        openingIndex = pos + 2;
      }
    }
    return openingIndex;

  }
  isAdded(carddata) {
    return (this.CompareCardData.indexOf(carddata) == '-1') ? true : false;
  }
  resetFlags() {
    this.selectedIndex = -1;
    this.knowMoreData = false;
    this.extraknowMoreData = false;
    this.viewMoreBtnVisible = true;
    this.viewMoreLessVisible = false;
  }
  // loadQdeForm(dcrPath,cardname){    
  //   catalogue_card_click(cardname);
  //   this.catalogueService.referpartnerDcr = dcrPath;  
  //   this.themeService.partnerDcr = dcrPath;  
  //   this.router.navigate(['./apply'], { queryParamsHandling: "preserve", skipLocationChange: false });
  //   if (document.body.classList.contains('re_comparebox_openes')) {
  //     document.querySelector('body').classList.remove('re_comparebox_openes')
  //   }
  //   (document.documentElement || document.body).scrollTop = 0;
  //    /* After Click of Apply */
  //   virtual_page_load(cardname,'sbi-card:eapply:eapplyform','Eapply');
  // } 

  // loadQdeForm(dcrPath, cardname) {
  //   console.log("cardname from cataloogue refer ===>", cardname);
  //   catalogue_card_click(cardname);
  //   this.catalogueService.referpartnerDcr = dcrPath;
  //   this.themeService.partnerDcr = dcrPath;
  //   if (cardname == 'AURUM Card') {
  //     window.location.href = "/eapply/campaign.page?path=personal/credit-cards/lifestyle/aurum-card.dcr&GEMID1=Refer&theme=aurum";
  //   } else {
  //     console.log("NAvigate to apply from loadQdeForm from catlogue-refer component");
  //     this.router.navigate(['./apply'], { queryParamsHandling: "preserve", skipLocationChange: false });
  //   }
  //   //this.router.navigate(['./apply'], { queryParamsHandling: "preserve", skipLocationChange: false });
  //   if (document.body.classList.contains('re_comparebox_openes')) {
  //     document.querySelector('body').classList.remove('re_comparebox_openes')
  //   }
  //   (document.documentElement || document.body).scrollTop = 0;
  //   /* After Click of Apply */
  //   virtual_page_load(cardname, 'sbi-card:eapply:eapplyform', 'Eapply');
  // }

  loadQdeForm(dcrPath, cardname) {
    console.log("cardname from cataloogue refer ===>", cardname);
    catalogue_card_click(cardname);
    this.catalogueService.referpartnerDcr = dcrPath;
    this.themeService.partnerDcr = dcrPath;
    console.log("entered in swiftRedirect function ==>", dcrPath);
    let cardName;
    this.dcrCardUrlMapping = this.iw.geteapplyCardUpgradeMappingDCR();
    this.eligibleCardList = this.iw.getsprintApplicableCardList();
    console.log("eligibleCardList====>", this.eligibleCardList);
    this.dcrCardUrlMapping.forEach(item => {
      console.log("entered in foreach block from swiftRedirect");
      if(item.key_value == dcrPath) {
        cardName = item.key_name;
        console.log("selected card type =====>", cardName);
      }
    });
    this.eligibleCardList.forEach(item => {
      if(item.key_name == "AllCards") {
        this.redirectToSwift = true;
      }
      else if(item.key_name == cardName) {
        this.redirectToSwift = true;
      }
    });
    if (this.redirectToSwift) {
      console.log("link should work from swiftRedirect function for card type MAX SBI card ==> ");
      let link = `${REDIRECT_SWIFT_URL}${cardName}?referralcode=${this.catalogueService.referralCode}&GEMID1=C2B_refer&GEMID2=C2B_refer`;
      // let link = `${REDIRECT_SWIFT_URL}${cardName}?referralcode=${this.catalogueService.referralCode}`;
      window.location.href = link;
    }
    else {
      if (cardname == 'AURUM Card') {
        window.location.href = "/eapply/campaign.page?path=personal/credit-cards/lifestyle/aurum-card.dcr&GEMID1=Refer&theme=aurum";
      } else {
        console.log("NAvigate to apply from loadQdeForm from catlogue-refer component");
        this.router.navigate(['./apply'], { queryParamsHandling: "preserve", skipLocationChange: false });
      }
      //this.router.navigate(['./apply'], { queryParamsHandling: "preserve", skipLocationChange: false });
      if (document.body.classList.contains('re_comparebox_openes')) {
        document.querySelector('body').classList.remove('re_comparebox_openes')
      }
      (document.documentElement || document.body).scrollTop = 0;
      /* After Click of Apply */
      virtual_page_load(cardname, 'sbi-card:eapply:eapplyform', 'Eapply');
    }
    
    
    
  }

  
  closeKnowMe() {
    this.resetFlags();
    this.knowMoreData = false;
    this.updateOrder();
  }
  showExtraKnowMore() {
    this.viewMoreBtnVisible = false;
    this.viewMoreLessVisible = true;
    this.extraknowMoreData = !this.extraknowMoreData;
  }
  hideExtraKnowMore() {
    this.extraknowMoreData = false;
    this.viewMoreBtnVisible = true;
    this.viewMoreLessVisible = false;
  }
  closeCompareBox() {
    this.showCompareBox = false;
    this.CompareCardData = [];
  }
  closeFullcompare() {
    this.showCompareDialog = false;
    document.querySelector('body').classList.remove('re_comparebox_openes');
  }
  showMobileCompareMenu() {
    this.isMobileCompare = !this.isMobileCompare;
  }
  addToCompare(carddata) {
    this.showCompareBox = true;
    if (this.CompareCardData.indexOf(carddata) === -1) {
      this.CompareCardData.push(carddata);
    }
  }
  updateIndex(index) {
    return index + 1;
  }
  showCompareDialogEvent() {
    this.showCompareDialog = true;
    (document.documentElement || document.body).scrollTop = 0;
    document.querySelector('body').classList.add('re_comparebox_openes');
  }
  goToAddCardView() {
    this.knowMoreData = false;
    (document.documentElement || document.body).scrollTop = 500;
  }
  goToAddCompCardView() {
    this.showCompareDialog = false;
    document.querySelector('body').classList.remove('re_comparebox_openes')
  }
  removeCard(item) {
    //this.CompareCardData.pop(item);
    let index = this.CompareCardData.indexOf(item);
    this.CompareCardData.splice(index, 1);
    this.knowMoreData = false;
  }
  removeFromCompare(item) {
    //this.CompareCardData.pop(item);

    let index = this.CompareCardData.indexOf(item);
    this.CompareCardData.splice(index, 1);
  }
  removeHTMLTags(res) {
    return res.replace(/<[^>]*>/g, '');
  }
  ngAfterViewInit() {
    this.renderer.listen(window, 'scroll', ($event) => {
      let compareboxDiv: any = document.querySelector('.re_fullcomparebox');
      if (compareboxDiv) {
        if (window.pageYOffset > 50) {
          this.compareboxScroll = true;
        } else {
          this.compareboxScroll = false;
        }
      }
    })
  }
  subContainerScroll() {
    if (this.isMobile) {
      let subCatContainer = document.getElementsByClassName("sub-category-container");
      $(".sub-category-container").scroll(function () {
        for (let i in subCatContainer)
          $(subCatContainer[i]).scrollLeft($(this).scrollLeft());
      });
    }
  }
  initiateScrollCheck(event) {
    if (this.isMobile) {
      const allColumns = document.querySelectorAll('.re_fullcomparebox .re_fullcomparebox_body_row:last-child > div');
      for (let i = 0; i < allColumns.length; i++) {
        let element: any = allColumns[i];
        if (event.target.scrollLeft > (element.offsetLeft + (element.offsetWidth / 2))) {
          if (document.querySelector('.re_fullcomparebox_footer .re_fullcomparebox_footer_inner a.isFixedActive')) {
            document.querySelector('.re_fullcomparebox_footer .re_fullcomparebox_footer_inner a.isFixedActive').classList.remove('isFixedActive')
          }
          document.querySelectorAll('.re_fullcomparebox_footer .re_fullcomparebox_footer_inner a')[i].classList.add('isFixedActive')
        }
      }
    }
  }

  swiftRedirect(path){
    console.log("entered in swiftRedirect function ==>", path);
    let cardName;
    this.dcrCardUrlMapping = this.iw.geteapplyCardUpgradeMappingDCR();
    this.dcrCardUrlMapping.forEach(item => {
      console.log("entered in foreach block from swiftRedirect");
      if(item.key_value == path) {
        cardName = item.key_name;
      }
    });
    // let _card = false;
    // if (cardType == "SPVU") {
    //   console.log("entered in if block of swiftRedirect function");
    //   window.location.href=`${base_https_url}/eapply/campaign.page?path=personal/credit-cards/lifestyle/aurum-card.dcr&GEMID1=Refer&theme=aurum`;
    // }
    // else {
      // console.log("entered in else block of swiftRedirect function");
      // this.sharedService.cardsContent.forEach(element => {
      //   if(element.cardType == cardType) {
      //     cardName = element.uniqueIdentifier;
      //     _card = true;
      //     console.log("card is present from swiftRedirect ==> ", cardName);
      //   }
      // })
      // if (!_card) {
      //   cardName = "simplyClick";
      //   console.log("card is not present from swiftRedirect ==> ", cardName);
      // }
      console.log("link should work from swiftRedirect function ==> ");
      let link = `${REDIRECT_SWIFT_URL}${cardName}?referralcode=${this.catalogueService.referralCode}&GEMID1=C2B_refer&GEMID2=C2B_refer`;
      // let link = `${REDIRECT_SWIFT_URL}${cardName}?referralcode=${this.catalogueService.referralCode}`;
      window.location.href = link;
      console.log("link working fine from swiftRedirect function ==> ", link);
    // }
  }

}
